import {
    SUCCESSFUL_ACCOUNT_PAYMENT,
    SUCCESSFUL_CONFIRM_PAYMENT_CREDIT_CARD,
    SUCCESSFUL_CC_URL_PAYMENT
} from "./actionConst";

import { storeObject } from 'utils/Storage/StorageUtils';
import { PAYMENT_DETAIL_STORAGE } from 'constants/storageConst';

const initialState = {
    info: {
        collection: {}
    },
    creditCardUrlPayment: {
        url: ""
    }
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SUCCESSFUL_ACCOUNT_PAYMENT:
            return {
                ...state,
                collection: action.payload
            }

        case SUCCESSFUL_CC_URL_PAYMENT:
            let newState = state;
            newState.onlinePaymentId = action.payload.onlinePaymentId;
            storeObject(PAYMENT_DETAIL_STORAGE, newState);
            return {
                ...state,
                onlinePaymentId: action.payload.onlinePaymentId,
                creditCardUrlPayment: action.payload
            }

        case SUCCESSFUL_CONFIRM_PAYMENT_CREDIT_CARD:
            return {
                ...state,
                collection: action.payload
            }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/payment/paymentReducer.js